import $ from 'jquery'
import 'slick-carousel'
import { createApp } from 'vue'
import FadeIn from '~/js/components/fadeIn'

const CLASS_NAME_TEIKIBIN_PRODUCT = 'js-teikibin-product'
const QUERY_CAROUSEL = '#product-carousel'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinProduct = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_PRODUCT
  )
  if (!elementsTeikibinProduct.length) return

  Array.from(elementsTeikibinProduct).forEach((element) => {
    createApp({
      name: 'SectionsTeikibinProduct',
      components: {
        FadeIn,
      },
      data() {
        return {
          showNextButton: false,
        }
      },
      mounted() {
        if (this.$refs['product-available']) this.showNextButton = true

        const elementArrowPrev = this.$refs.elementArrowPrev
        const elementArrowNext = this.$refs.elementArrowNext
        $(QUERY_CAROUSEL).slick({
          centerMode: true,
          centerPadding: '60px',
          prevArrow: elementArrowPrev,
          nextArrow: elementArrowNext,
          responsive: [
            {
              breakpoint: 500,
              settings: {
                centerPadding: '40px',
              },
            },
          ],
        })

        window.addEventListener('fader-image-clicked', (event) => {
          const index = event.detail.index
          $(QUERY_CAROUSEL).slick('slickGoTo', index)
          this.$refs['carousel-wrapper'].scrollIntoView()
        })
      },
      methods: {
        showPopup(eventName) {
          window.dispatchEvent(new CustomEvent(eventName))
        },
      },
    }).mount(element)
  })
})
